import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

export type AddendaId = 'sanofi';

export type AddendaValidator = (data: any) => { valid: boolean; message?: string };

export type AddendaRegistryItem = {
  id: AddendaId;
  label: string;
  description?: string;
  icon?: any;
  validate: AddendaValidator;
  fields: Array<{ name: string; label: string; type: 'text' | 'email'; placeholder?: string; required?: boolean }>;
  apiType: string; // value for API `tipo`
  preconditions?: (comprobante: any) => { warning?: string; disabled?: boolean };
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ADDENDAS_REGISTRY: AddendaRegistryItem[] = [
  {
    id: 'sanofi',
    label: 'SANOFI',
    description: 'Addenda SANOFI (NUM_ORDEN, CORREO_SANOFI)',
    icon: ReceiptLongIcon,
    validate: (data) => {
      if (!data?.NUM_ORDEN || String(data.NUM_ORDEN).trim() === '') return { valid: false, message: 'NUM_ORDEN es requerido' };
      if (!data?.CORREO_SANOFI || !emailRegex.test(String(data.CORREO_SANOFI))) return { valid: false, message: 'CORREO_SANOFI inválido' };
      return { valid: true };
    },
    apiType: 'sanofi',
    fields: [
      { name: 'NUM_ORDEN', label: 'NUM_ORDEN', type: 'text', required: true },
      { name: 'CORREO_SANOFI', label: 'CORREO_SANOFI', type: 'email', required: true },
    ],
    preconditions: (c) => {
      if (!c) return {};
      if (c.rfc && c.rfc !== 'SPA960328P62') {
        return { warning: 'El receptor no es SANOFI (SPA960328P62).' };
      }
      return {};
    },
  },
  {
  id: 'dummy' as any,
  label: 'Proveedor X',
  description: 'Demo: addenda ficticia',
  icon: ReceiptLongIcon,
  validate: (data) => {
  if (!data?.REQ_ID) return { valid: false, message: 'REQ_ID es requerido' };
  return { valid: true };
  },
  apiType: 'dummy',
  fields: [
  { name: 'REQ_ID', label: 'REQ_ID', type: 'text', required: true },
  { name: 'EMAIL_CONTACTO', label: 'EMAIL_CONTACTO', type: 'email' },
  ],
  preconditions: () => ({ warning: 'Addenda de demostración (no implementada en backend)' }),
  }  
];
